"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AmountDisplay = AmountDisplay;
var jsx_runtime_1 = require("react/jsx-runtime");
// ================================================================
// v2/components/AmountDisplay/index.tsx
// Figma: AmountDisplay/Yen/Large — 金額の強調表示。
//
// 数字は既存画面と同じ Oswald (utoniq-ui の EmphasizedNumber と同じ扱い)。
// size:
//   lg (既定) — 24px / letterSpacing 1.2 (枚数選択シートの価格)
//   md        — 16px (確認画面の合計など)
//
// 色は theme.palette.v2 (useV2Palette) から取得する。
// ================================================================
var material_1 = require("@mui/material");
var theme_1 = require("../../theme");
var tokens_1 = require("../../tokens");
function AmountDisplay(_a) {
    var children = _a.children, _b = _a.size, size = _b === void 0 ? 'lg' : _b, color = _a.color;
    var p = (0, theme_1.useV2Palette)();
    var isLarge = size === 'lg';
    return ((0, jsx_runtime_1.jsx)(material_1.Typography, { component: "span", sx: {
            fontFamily: 'Oswald',
            fontWeight: tokens_1.fontWeight.normal,
            fontSize: isLarge ? tokens_1.fontSize.xl : tokens_1.fontSize.base,
            lineHeight: "".concat(isLarge ? tokens_1.fontSize.xl : tokens_1.lineHeight.md, "px"),
            letterSpacing: isLarge ? '1.2px' : undefined,
            color: color !== null && color !== void 0 ? color : p.foreground.neutral.primary,
            whiteSpace: 'nowrap',
        }, children: children }));
}
